import { render, staticRenderFns } from "./VisionTherapyExperts.vue?vue&type=template&id=45b11ffc&scoped=true"
import script from "./VisionTherapyExperts.vue?vue&type=script&lang=js"
export * from "./VisionTherapyExperts.vue?vue&type=script&lang=js"
import style0 from "./VisionTherapyExperts.vue?vue&type=style&index=0&id=45b11ffc&prod&scoped=true&lang=scss"
import style1 from "./VisionTherapyExperts.vue?vue&type=style&index=1&id=45b11ffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b11ffc",
  null
  
)

export default component.exports